import createBreakpoint from 'shared-tokens/utils/breakpoints';

import { mainCls as baseCls } from '../../style';

const brpM = createBreakpoint('m');

export const btnCls = `${baseCls}__notBtn`;
export const accCls = `${baseCls}__notAcc`;
export const iconClsOn = `${baseCls}__icon-cnt`;
export const iconClsOff = `${baseCls}__icon-cnt-off`;


export default {
  [accCls]: {
    '& .accordion-item-shared__head': {
      height: '48px',
      [brpM]: {
        height: '40px',
      },
    },
    '& .accordion-item-shared__body': {
      paddingRight: 16,
      transition: 'max-height 0.3s   cubic-bezier(.4, 0, 0.2, 1)',
    },
    '& .accordion-item-shared__children': {
      paddingLeft: 40,
    },
  },
  [btnCls]: {
    margin: 0,
    padding: 0,
    border: '0 none',
  },
  [iconClsOn]: {
    width: '24px',
    height: '24px',
    color: '#ffb505',
  },
  [iconClsOff]: {
    width: '24px',
    height: '24px',
    color: '#96a1b0',
  }
};
